// Module
var code = "<span> <a href class=\"btn btn-success\" ng-if=\"!$ctrl.checkIfInCart()\" ng-click=\"$ctrl.add()\"><span> {{ 'checkout.add_to_cart' | t }} </span><i class=\"fas fa-shopping-cart\"></i></a> <a href=\"/cart\" class=\"btn btn-dark\" ng-if=\"$ctrl.checkIfInCart()\">{{ 'checkout.in_cart' | t }} <i class=\"fas fa-shopping-cart\"></i></a> </span> ";
// Exports
module.exports = code;